import { AccordionDetails, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import React from 'react';

const Supplies: React.FunctionComponent<any> = ({ handleCheck, isDisable, validationObj, disable }) => {
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        <Grid md={12}>
          <Grid container mt={1} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Are study supplies current and adequate, including lab kits?
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvrp_supply"
                  value={validationObj.stdy_imvrp_supply}
                  onChange={e => handleCheck(e, 'section8')}
                >
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_supply == 'Y' ? true : false}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    disabled={!isDisable || disable}
                    checked={validationObj.stdy_imvrp_supply == 'N' ? true : false}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.25 }}>
              <TextField
                name="stdy_imvrp_supply_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvrp_supply_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section8')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
                InputLabelProps={{ shrink: validationObj.stdy_imvrp_supply_comm }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default Supplies;
